import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DesktopNavComponent from './DesktopNav.styles';
import { AboutUsSubNav, ProductsSubNav } from './DesktopNav.styles';
import { FavouritesButton, SearchButton } from '../../MainNav.styles';
import Hamburger from '../Hamburger/Hamburger.jsx';
import NavLink from '../../../NavLink/NavLink';
import Link from '../../../shared/Link/Link';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import Icon from '../../../shared/Icon/Icon';
import MainNavAboutUsLink from '../MainNavAboutUsLink/MainNavAboutUsLink.jsx';
import MainNavProductLink from '../MainNavProductLink/MainNavProductLink.jsx';
import MainNavRibbon from '../MainNavRibbon/MainNavRibbon.jsx';
import { underlineText } from '../../../../helpers/stringHelpers';
import { mediaApi } from '@sitecore-jss/sitecore-jss-react';
import Overlay from '../../../shared/Overlay/Overlay';
import Button from "../../../shared/Button/Button";
import BocaLogo from '../../../../assets/images/BocaRatonBowl.png';

export const DesktopNav = ({
        fields,
        sitecoreContext: { globalContent, route, site },
        search,
        setSearch,
        className,
        ...props
    }) => {
    const links = globalContent?.navigation;
    const utilityLinks = globalContent?.utilityLinks;
    const logo = globalContent?.logo;
    const navigation = globalContent?.navigation;
    const homePageLink = globalContent?.homepageLink;
    const languageSelector = globalContent?.languageSelectorItems;
    const heartLink = globalContent?.heartLink;
    const heartIcon = globalContent?.heartIcon;

    const ProductsText =
        Array.isArray(links) &&
        links.find(
            ({ type, cards }) =>
                type === 'megamenu-cards' && cards && cards.filter(({ type }) => type === 'product').length > 0
        )?.text;
    const [subNav, setSubNav] = useState(false);

    const supportingLinks = navigation?.reduce((acc, el) => {
        if (el?.supportingLinks?.length) {
            return el.supportingLinks;
        }
        return [...acc];
    }, []);

    const handleLanguageSelector = (newLangCode) => {
        if (!newLangCode) return;

        if (!isServer()) {
            let splitPath = window.location.pathname.split('/');
            splitPath[1] = newLangCode;
            return (window.location.href = splitPath.join('/'));
        }
    };

   
    return (
      <>
        <DesktopNavComponent
          search={search ? 'true' : undefined}
          className={`hide-on-print nav-${className}`}
        >
          <Hamburger className="hamburger" />
          <nav aria-label="Main Navigation" role="navigation" className="hide-on-print">
            {Array.isArray(links) &&
              links.map(({ path, title, type, cards }, index) => {
                if (type && type === 'megamenu-cards') {
                  if (cards && cards.filter(({ type }) => type === 'product').length > 0) {
                    return (
                      <NavLink
                        key={`${index}-${title}`}
                        text={title}
                        subNav
                        active={subNav === 'products' ? 'true' : 'false'}
                        path={path}
                        aria-haspopup={type === 'megamenu-cards' ? 'true' : undefined}
                        onClick={(event) => {
                          event.preventDefault();
                          if (subNav === 'about-us') {
                            setSubNav('products');
                            return;
                          }
                          if (subNav === 'products') {
                            setSubNav(false);
                            return;
                          }
                          setSubNav('products');
                        }}
                      />
                    );
                  }
                  if (cards.filter(({ type }) => type === 'page').length > 0) {
                    return (
                      <NavLink
                        key={`${index}-${title}`}
                        text={title}
                        subNav
                        active={subNav === 'about-us' ? 'true' : 'false'}
                        onClick={(event) => {
                          event.preventDefault();
                          if (subNav === 'products') {
                            setSubNav('about-us');
                            return;
                          }
                          if (subNav === 'about-us') {
                            setSubNav(false);
                            return;
                          }
                          setSubNav('about-us');
                        }}
                      />
                    );
                  }
                }
                return <NavLink key={`${index}-${title}`} text={title} path={path} />;
              })}

          </nav>
          <div className="logo hide-on-print">
            <Link href={homePageLink}>
              {route?.fields?.pageTitle?.value === 'Boca Raton Bowl' ? (
                <img
                  src={BocaLogo}
                  alt="Boca Raton Bowl logo"
                  width={200}
                  height={200}
                  className="boca-logo"
                  aria-label="Boca Raton Bowl logo"
                />
              ) : (
                <Image
                  field={logo}
                  srcSet={[{ mw: 200, mh: 200 }]}
                  sizes="200"
                  size="200"
                  width="200"
                  height="113"
                />
              )}
            </Link>
          </div>

          <div aria-label="Utility Navigation" role="menu" className="nav-end hide-on-print">
            {Array.isArray(languageSelector) && languageSelector.length
              ? languageSelector.map(({ text, code }, index) => {
                  return (
                    <NavLink
                      className="nav-end-link"
                      role="menuitem"
                      key={`languageSelector-${index}-${text}`}
                      text={text}
                      onClick={() => handleLanguageSelector(code)}
                    />
                  );
                })
              : null}
            {Array.isArray(utilityLinks) &&
              utilityLinks.map(({ title, path, href }, index) => {
                return (
                  <NavLink
                    className="nav-end-link"
                    role="menuitem"
                    key={`${index}-${title}`}
                    text={title}
                    path={path}
                    href={href}
                  />
                );
              })}
            {site?.name !== 'bushs-beans-foodservices' ? (
              <>
                <FavouritesButton
                  aria-label="Add to Favorites"
                  role="menuitem"
                  className="fave-button"
                >
                  <Link path={heartLink?.path}>
                    <img src={heartIcon?.src} alt={heartIcon?.alt} title="My Favorites" />
                  </Link>
                </FavouritesButton>
                <SearchButton
                  id="search-button"
                  className="search-button"
                  role="menuitem"
                  disabled={route?.name === 'search'}
                  title={search ? 'Close Search' : 'Open Search'}
                  aria-label={search ? 'Close Search' : 'Open Search'}
                  onClick={() => {
                    setSearch((prevState) => !prevState);
                  }}
                >
                  <Icon className="search" icon={search ? 'cross' : 'search'} size="lg" />
                </SearchButton>
              </>
            ) : (
              <Button
                id="MainNavBtn"
                role="menuitem"
                target="_blank"
                text="Contact a Rep"
                size="small"
                href="/contact"
                variant="yellowBlue"
              />
            )}
          </div>
          <AboutUsSubNav active={subNav === 'about-us'}>
            <div className="card-list">
              {Array.isArray(links) &&
                links
                  .find(
                    ({ type, cards }) =>
                      type === 'megamenu-cards' &&
                      cards &&
                      cards.filter(({ type }) => type === 'page').length > 0
                  )
                  ?.cards.map(({ title, image, alt, link }, index) => {
                    return (
                      image?.src && (
                        <MainNavAboutUsLink
                          key={`${index}-${title}`}
                          text={title}
                          src={mediaApi.updateImageUrl(image.src, { mw: 300, mh: 300 })}
                          alt={`view ${alt} page`}
                          path={link?.path}
                          isHeading={false}
                        />
                      )
                    );
                  })}
            </div>
          </AboutUsSubNav>
          <ProductsSubNav active={subNav === 'products'}>
            <div className="container">
              <h2
                className="h1"
                role="presentation"
                dangerouslySetInnerHTML={{
                  __html: ProductsText
                    ? underlineText(ProductsText, {
                        openTag: '<u>',
                        closeTag: '</u>',
                      })
                    : '',
                }}
              />
              <div className="product-list">
                {Array.isArray(links) &&
                  links
                    .find(
                      ({ type, cards }) =>
                        type === 'megamenu-cards' &&
                        cards &&
                        cards.filter(({ type }) => type === 'product').length > 0
                    )
                    ?.cards.map(({ title, image, link }, index) => {
                      return (
                        image?.src && (
                          <MainNavProductLink
                            key={`${index}-${title}`}
                            productName={title}
                            productImage={mediaApi.updateImageUrl(image.src, { mw: 300, mh: 300 })}
                            buttonText={link?.title}
                            path={link?.path}
                          />
                        )
                      );
                    })}
              </div>
            </div>
            {supportingLinks?.length && <MainNavRibbon supportingLinks={supportingLinks} />}
          </ProductsSubNav>
        </DesktopNavComponent>
        {(subNav === 'products' || subNav === 'about-us') && (
          <Overlay id="overlay" onClick={() => setSubNav('')} />
        )}
      </>
    );
};

DesktopNav.propTypes = {
  fields: PropTypes.object,
  sitecoreContext: PropTypes.object,
  search: PropTypes.bool,
  setSearch: PropTypes.func,
  className: PropTypes.string,
};

export default withSitecoreContext()(DesktopNav);